// exp_PORTFOLIO-58018_file
import { FC } from 'react';

import vrPackageBannerCloseButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/vr_package/vr_package_banner_close_button_click';
import { Banner, Text, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    tip: 'VrCampaignBuilderPage.tip',
};
export const MobileScreensTip: FC = () => {
    const [isMobileBannerVisible, , setIsMobileBannerVisibleOff] = useOnOffState(true);

    const { isMobile } = useBreakpoint();
    const trls = useTrls();

    if (!isMobile) {
        return null;
    }

    const handleClose = () => {
        setIsMobileBannerVisibleOff();
        vrPackageBannerCloseButtonClick();
    };

    return (
        <>
            <Banner
                visible={isMobileBannerVisible}
                onClose={handleClose}
                style="secondary"
                size="small"
                styleClose="secondary"
                content={<Text>{trls(TrlKeys.tip)}</Text>}
                stretched
                data-qa="vr-campaign-mobile-tip-banner"
            />
            <VSpacing default={32} />
        </>
    );
};
